//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { declarationRecordQueryPage, queryCargoDeclareBalanceRecord, updateDeclareSettleStatus, cargoDeclareDC, BASE, BASE_PATH } from '@/api/importedColdChain';
import { download, getExcelPath } from "@/api/baseDataManage";
export default {
  name: 'CargoDeclareBalance',
  data: function data() {
    return {
      cargoDeclareDC: true,
      baseUrl: BASE + BASE_PATH,
      // 查询条件
      form: {
        pageNo: 1,
        pageSize: 10,
        cargoApplicationNo: '',
        declareStartDate: '',
        declareEndDate: '',
        customsListNo: '',
        protocolNo: '',
        insuredName: '',
        applicationNo: '',
        isBalance: ''
      },
      total: 0,
      //数据条数
      // 列表数据
      tableData: [{
        companyCode: "1121",
        companyName: "12312"
      }],
      loading: false
    };
  },
  created: function created() {
    this.userType = this.$store.state.user.userinfo.userType;
    console.log(this.userType);
  },
  mounted: function mounted() {
    // 加载数据
    this.getData();
  },
  filters: {
    isBalance: function isBalance(value) {
      if (value == '1') return '已结算';else if (value == '0') return '未结算';
    }
  },
  methods: {
    //   查询
    submitForm: function submitForm() {
      this.form.pageNo = 1;
      this.getData();
    },
    settle: function settle(data) {
      var _this = this;

      console.log(data); // this.$alert('<p>提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
      //   dangerouslyUseHTMLString: true,
      //   confirmButtonText: '确定',
      //   callback: action => {
      //    console.log("qwer")
      //   }
      // })

      this.$confirm('是否确认该单申报已结算', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        console.log('1234');
        var params = {
          cargoApplicationNo: data.cargoApplicationNo || '',
          applicationNo: data.applicationNo || '',
          protocolNo: data.protocolNo
        };
        updateDeclareSettleStatus(params).then(function (res) {
          if (res.rtnCode == '0000') {
            _this.$message({
              message: '结算成功',
              type: 'success'
            });

            data.isBalance = '1';
          } else {
            _this.$message({
              message: '结算失败',
              type: 'success'
            });
          }
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消结算'
        });
      });
      console.log('---结算end---');
    },
    // 获取数据
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      this.form.cargoApplicationNo = this.form.cargoApplicationNo || '';
      this.form.declareStartDate = this.form.declareStartDate || '';
      this.form.declareEndDate = this.form.declareEndDate || '';
      this.form.protocolNo = this.form.protocolNo || '';
      this.form.insuredName = this.form.insuredName || '';
      queryCargoDeclareBalanceRecord(this.form).then(function (res) {
        _this2.loading = false;
        _this2.total = res.totalCount;
        _this2.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm() {
      this.form.cargoApplicationNo = '';
      this.form.protocolNo = '';
      this.form.insuredName = '';
      this.form.declareStartDate = '';
      this.form.declareEndDate = '';
      this.getData();
    },
    // 货物申报结算清单导出
    listCargoDc: function listCargoDc() {
      cargoDeclareDC({
        protocolNo: this.form.protocolNo || '',
        insuredName: this.form.insuredName || '',
        cargoApplicationNo: this.form.cargoApplicationNo || '',
        declareStartDate: this.form.declareStartDate || '',
        declareEndDate: this.form.declareEndDate || ''
      }).then(function (res) {
        var blob = new Blob([res], {
          type: 'application/vnd.ms-excel'
        }); // 兼容ie

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, '货物申报结算清单.xls');
        } else {
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a'); // 创建a标签

          link.href = url;
          link.download = '货物申报结算清单.xls'; // 重命名文件

          link.click();
          window.URL.revokeObjectURL(url); // 释放内存
        }
      });
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    showDetail: function showDetail(data) {
      this.$router.push({
        path: '/importedColdChain/declarationRecord/' + data.cargoapplicationno
      });
    }
  }
};